import useAuthFormViewModel from './AuthFormViewModel'
import useAdminAuth from '@hook/useAdminAuth'
import cn from 'clsx'

import AuthForm from './AuthForm'
import { Link } from 'react-router-dom'

import './SignIn.css'

const SignIn = () => {
    
    const viewModel = useAuthFormViewModel()
    
    const { successfulLogins } = useAdminAuth()
    
    return (
        
        <div
            className={cn('SignIn', {
                'flex gap-4': !!successfulLogins,
            })}>
            
            {successfulLogins && (
                <div className="w-96 flex flex-col items-center justify-center min-h-screen">
                    <div>
                        <div className="py-2 border-b border-base-300/30">
                            <p className="text-base font-bold">Saved Logins</p>
                            <p className="text-sm italic text-red-300">Only visible to admins on develop.</p>
                        </div>
                        <ul className="py-2">
                            {Object.keys(successfulLogins).map(email => (
                                <li key={email}>
                                    <button
                                        className="btn btn-ghost"
                                        onClick={() => viewModel.onSignInSubmit(null, {
                                            email,
                                            password: successfulLogins[email],
                                        })}>
                                        {email}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
            
            <AuthForm
                viewModel={viewModel}
                onSubmit={e => viewModel.onSignInSubmit(e)}
                submitButtonText="Sign In"
                cancelButtonText="Sign Up"
                cancelButtonLink="/signup">
                
                <input
                    className="input input-bordered w-full"
                    type="email"
                    value={viewModel.email}
                    autoComplete="email"
                    onChange={e => viewModel.setEmail(e.target.value)} />
                
                <div className="relative mt-3">
                    <input
                        className="input input-bordered w-full !input-md"
                        type="password"
                        value={viewModel.password}
                        autoComplete="current-password"
                        onChange={e => viewModel.setPassword(e.target.value)} />
                </div>
                
                <Link className="block text-right text-slate-400 mt-2 mb-6" to="/forgotpassword">
                    Forgot password?
                </Link>
                
                {/*
                2023-05-29
                @todo Hid this b/c it doesn't do anything
                */}
                {/* <div className="mb-2 flex justify-between items-center">
                    <div className="mb-3 form-check">
                        <input type="checkbox" className="form-check-input filled-in" id="new" />
                        <label className="form-check-label small card-link-secondary">Remember me</label>
                    </div>
                </div> */}
            
            </AuthForm>
        
        </div>
        
    )
    
}

export default SignIn
